import React, { Component } from 'react';
import LinkButton from '../LinkButton';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import * as MySound from '../MySound';
import ModalYesNo from '../MXDock/ModalYesNo';
import ModalOK from '../MXDock/ModalOk';

export class UpdateLocationCharge extends Component {
    static displayName = UpdateLocationCharge.name;
    allowLoginLevel = ["MM", "SM"];

    constructor(props) {
        super(props);
        this.state =
        this.history = props.history;
        this.reset();
    }

    componentDidMount() {
        this.getLocationStatuses();
        this.getLocationChargeTypes();
        if (!MyGlobal.userAllowed(this.allowLoginLevel)) {
            this.setState({ alertMessage: "Please contact Senior Manager to update the Location Status and Charge" });
        }
    }
    goto(page) {
        this.history.push(page);
    }

    reset(setState) {
        this.state = {
            loading: true,
            alertMessage: "",
            selectedLocationText: "",
            selectedLocationId: 0,
            locationValidated: false,
            locationStatuses: [],
            chargeTypes: [],
            selectedStatus: "",
            selectedStatusId: "0",
            selectedChargeType: "",
            selectedChargeTypeId: "0",
            displayStatusWarning: false,
            displayUpdateSuccessDialog : false
        };
        if (setState) {
            this.setState(this.state);
            this.getLocationStatuses();
            this.getLocationChargeTypes();
            this.txtLocation.focus();
        }
        if (!MyGlobal.userAllowed(this.allowLoginLevel)) {
            this.setState({ alertMessage: "Please contact Senior Manager to update the Location Status and Charge" });
        }
    }
    getLocationStatuses() {
        this.setState({ loading: true, alertMessage: "" });

        fetch(`api/Location/GetLocationStatuses`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load location statuses!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            data.push({ id: 0, desc: "<--Select-->" });
                            this.setState({ locationStatuses: data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load statuses!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load statuses!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    getLocationChargeTypes() {
        this.setState({ loading: true, alertMessage: "" });

        fetch(`api/Location/GetLocationChargeTypes`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load Charge Types!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            data.push({ id: 0, desc: "<--Select-->" });
                            this.setState({ chargeTypes: data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Charge Types!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Charge Types!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    txtKeyPressed(e) {
        if (e?.which == 13) {
            this.handleSelectedLocation();
        }
    }
    async handleSelectedLocation() {

        await this.getLocationStatus(this.state.selectedLocationText)

    }

    async getLocationStatus(locationBarcode) {
        var warehouseID = MyGlobal.warehouse;
        var url = `api/Tote/GetLocationStatusByBarcode?warehouseID=${warehouseID}&barcode=${locationBarcode}`;
        const response = await fetch(url, {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        //Read the response and normal, continue , if invalid return an error
        if (data != null) {
            if (data.length > 0) {

                let status = "";
                let charge = "";
                let locId = 0;
                for (var value of data) {
                    status = value.Status;
                    charge = value.Charge;
                    locId = value.LOC_ID;
                }
           
                const selectedLocationStatus = this.state.locationStatuses.find((element) => {
                    return element.desc.toString() === status.toString();
                });
                const selectedLocationChargeType = this.state.chargeTypes.find((element) => {
                    return element.desc.toString() === charge.toString();
                });
                const statusId = selectedLocationStatus ? selectedLocationStatus.id.toString() : "0";
                const chargeTypeId = selectedLocationChargeType ? selectedLocationChargeType.id.toString() : "0";

                this.setState({ alertMessage: "", locationValidated: true, selectedLocationId: locId, selectedStatus: status, selectedChargeType: charge, selectedStatusId: statusId, selectedChargeTypeId: chargeTypeId });

               

                return;
            }
        }

        MySound.play(MySound.Sound.stop);
        this.setState({ alertMessage: "Location not found", locationValidated: false, selectedStatusId: "0", selectedChargeTypeId: "0" });

    }
    validateLocationStatus() {
        this.setState({ loading: true, alertMessage: "" });

        if (!this.state.locationValidated || this.state.selectedLocationId === 0) {
            this.setState({ alertMessage: "Please scan the location" });
            return;
        }
        if (this.state.selectedStatusId === "6") {
            this.updateLocationStatusCharge();
        }
        else //selected Status != Normal(6), Check if Location has Inventories
        {
            fetch(`api/Location/GetLocationInventories?locationId=${this.state.selectedLocationId}`)
                .then(async response => {
                    this.setState({ loading: false });
                    // check for error response
                    if (!response.ok) {
                        const errorText = await response.text();
                        console.error(errorText);
                        this.setState({ alertMessage: "Failed to check if Location has Inventories!!" });
                        return;
                    }
                    else {
                        const isJson = response.headers.get('content-type')?.includes('application/json');
                        const apiResponse = isJson ? await response.json() : null;
                        if (apiResponse) {
                            
                            if (apiResponse.success) {
                                const locationInventories = apiResponse.data;
                                
                                if (locationInventories != null && locationInventories.length > 0) {

                                    if (this.state.selectedStatusId === "10") {
                                        this.setState({ alertMessage: "This location can't be void as has inventory" });
                                        MySound.play(MySound.Sound.stop);
                                        return;
                                    }
                                    else {
                                        this.setState({ displayStatusWarning: true });
                                        return;
                                    }

                                }
                                else {
                                    this.updateLocationStatusCharge();
                                }
                            }
                            else {
                                this.setState({ alertMessage: "Failed to check if Location has Inventories!!" });
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to check if Location has Inventories!!" });
                        }
                    }
                })
                .catch(error => {
                    this.setState({ alertMessage: error });
                });

        }
       
    }

    updateLocationStatusCharge() {
        this.setState({ loading: true, alertMessage: "", displayStatusWarning: false });

        if (!this.state.locationValidated || this.state.selectedLocationId === 0) {
            this.setState({ alertMessage: "Please scan the location" });
            return;
        }
       
        var updateLocationStatusChargeRequest = {
            locationId: this.state.selectedLocationId,
            locationStatusId: this.state.selectedStatusId,
            LocationChargeTypeId: this.state.selectedChargeTypeId
        };
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updateLocationStatusChargeRequest)
        };

        fetch(`api/Location/UpdateLocationStatusAndCharge`, requestOptions)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success) {
                            this.txtLocation.focus();
                            this.setState({ displayUpdateSuccessDialog: true });
                         
                        }
                        else {
                            this.setState({ alertMessage: apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to update Location Status and Charge!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
    render() {
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Location Update</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('SupervisorMenu'); }} >
                            Back
                        </button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={5}><h5>Scan to check Current Status</h5></Col>
                    </Row>
                    <Row>
                        <Col xs={3}> <label htmlFor="txtLocation">Location :</label> </Col>
                        <Col xs={9}>
                            <div className="form-group">
                                <input type="text" className="form-control" name="txtLocation" id="txtLocation" disabled={!MyGlobal.userAllowed(this.allowLoginLevel)}
                                    autoFocus="autofocus" 
                                    value={this.state.selectedLocationText}
                                    ref={(input) => { this.txtLocation = input; }}
                                    onKeyPress={(e) => { this.txtKeyPressed(e); }}
                                    onChange={(e) => {
                                        this.setState({ selectedLocationText: e.target.value, alertMessage: "", selectedChargeType: "", locationValidated: false, selectedStatusId: 0, selectedChargeTypeId: 0 });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>Status : </Col>
                        <Col xs={9}>
                            <select className="form-select form-control" aria-label=".form-select-lg example" value={this.state.selectedStatusId} disabled={!this.state.locationValidated}
                                onChange={(e) => {
                                    this.setState({ selectedStatusId: e.target.value });
                                }} >
                                {this.state.locationStatuses.map(row =>
                                    <option key={row.id} value={row.id}>{row.desc}</option>
                                )}
                            </select>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>Charge : </Col>
                        <Col xs={9}>
                            <select className="form-select form-control" aria-label=".form-select-lg example" value={this.state.selectedChargeTypeId} disabled={!this.state.locationValidated}
                                onChange={(e) => {
                                    this.setState({ selectedChargeTypeId: e.target.value });
                                }} >
                                {this.state.chargeTypes.map(row =>
                                    <option key={row.id} value={row.id}>{row.desc}</option>
                                )}
                            </select>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => this.validateLocationStatus()} disabled={!MyGlobal.userAllowed(this.allowLoginLevel)} >Update</button>
                        </Col>
                    </Row> 
                    <Row className="mb-3">
                        <Col xs={12}>
                            <button className="btn btn-success col-12 mb-2" onClick={() => { this.reset(true); }} disabled={!MyGlobal.userAllowed(this.allowLoginLevel)} >Refresh</button>
                        </Col>
                    </Row>

                </Container>
                <ModalYesNo title="Warning !!" show={this.state.displayStatusWarning} message="This location has Inventory. Updating the status will prevent picking of products. Do you want to proceed ?" onClickNo={(e) => { this.setState({ displayStatusWarning: false }) }} onClickYes={() => { this.updateLocationStatusCharge(); }}></ModalYesNo>
                <ModalOK title="Update Successful" show={this.state.displayUpdateSuccessDialog} message="Successfully updated Location Status and Charge Type" onClickOk={() => { this.reset(true); }}  ></ModalOK>

            </div>
        );

    }


}
